import { render, staticRenderFns } from "./DepartureAndArrivalItem.vue?vue&type=template&id=20e85a02"
import script from "./DepartureAndArrivalItem.vue?vue&type=script&lang=js"
export * from "./DepartureAndArrivalItem.vue?vue&type=script&lang=js"
import style0 from "./DepartureAndArrivalItem.vue?vue&type=style&index=0&id=20e85a02&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports